import React from 'react';
import { FaGavel } from 'react-icons/fa';

function Category({ name, id, toggleAltCategories, image }) {
    return (
        <div className='herrac-category' onClick={() => toggleAltCategories(id)}>
            <div className="herrac-category__image">
                <img 
                    src={`https://api.herracim.az/HerracImages/categoriesImages/${image}`} 
                    alt={name}
                />
                <div className="herrac-category__overlay">
                    <FaGavel className="herrac-category__icon" />
                </div>
            </div>
            <p className="herrac-category__name">{name}</p>
            <span className="herrac-category__badge">Hərraclar</span>
        </div>
    );
}

export default Category;